module.exports = __webpack_public_path__ + "img/elec_month.de9e07a1.png";